(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fold-styles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('cart:update', event => {
 const count = event.detail?.data?.itemCount;
 if (typeof count === 'number') document.querySelectorAll('[data-fold-cart-count]').forEach(node => { node.textContent = count; });
});
  } catch(e) { console.error(e); }
})();

})();
